document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-site-nav]');

  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var isOpen = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });

    nav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        nav.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  // Scroll reveal — subtle fade/slide-in as sections enter the viewport.
  // Respects prefers-reduced-motion and degrades gracefully without IntersectionObserver.
  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var revealEls = document.querySelectorAll('[data-reveal]');

  if (revealEls.length) {
    if (prefersReducedMotion || typeof IntersectionObserver === 'undefined') {
      revealEls.forEach(function (el) { el.classList.add('is-revealed'); });
    } else {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

      revealEls.forEach(function (el) { observer.observe(el); });
    }
  }

  /* =====================================================================
     CART FUNCTIONALITY
     AJAX quantity updates and item removal via Shopify Cart API.
     After each update, reloads the cart page to ensure proper price
     formatting (handled by Shopify's Liquid money filters).
     ===================================================================== */

  var cartForm = document.getElementById('cart-form');

  if (!cartForm) return;

  // Update a single line item quantity via Shopify AJAX API
  function updateLineItem(line, quantity) {
    var lineEl = document.querySelector('[data-cart-item][data-line="' + line + '"]');
    if (lineEl) {
      lineEl.classList.add('is-updating');
      if (quantity === 0) {
        lineEl.classList.add('is-removing');
      }
    }

    var formData = new FormData();
    formData.append('line', line);
    formData.append('quantity', quantity);

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        // Update the cart count badge in the header
        var countEls = document.querySelectorAll('[data-cart-count]');
        countEls.forEach(function (el) {
          if (cart.item_count > 0) {
            el.textContent = cart.item_count;
            el.style.display = '';
          } else {
            el.style.display = 'none';
          }
        });

        // Reload the page to get properly formatted prices from Liquid
        // This ensures correct currency formatting for any store locale
        window.location.reload();
      })
      .catch(function (error) {
        if (lineEl) {
          lineEl.classList.remove('is-updating', 'is-removing');
        }
        // Fallback: submit the form to update quantities
        cartForm.submit();
      });
  }

  // Quantity decrement (−)
  document.querySelectorAll('[data-quantity-decrement]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var line = btn.getAttribute('data-line');
      var input = document.querySelector('[data-quantity-input][data-line="' + line + '"]');
      if (input) {
        var newVal = Math.max(0, parseInt(input.value, 10) - 1);
        input.value = newVal;
        updateLineItem(line, newVal);
      }
    });
  });

  // Quantity increment (+)
  document.querySelectorAll('[data-quantity-increment]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var line = btn.getAttribute('data-line');
      var input = document.querySelector('[data-quantity-input][data-line="' + line + '"]');
      if (input) {
        var newVal = parseInt(input.value, 10) + 1;
        input.value = newVal;
        updateLineItem(line, newVal);
      }
    });
  });

  // Quantity input change (manual entry)
  document.querySelectorAll('[data-quantity-input]').forEach(function (input) {
    var debounceTimer;
    input.addEventListener('change', function () {
      var line = input.getAttribute('data-line');
      var newVal = Math.max(0, parseInt(input.value, 10) || 0);
      input.value = newVal;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        updateLineItem(line, newVal);
      }, 300);
    });
  });

  // Remove item button
  document.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var line = btn.getAttribute('data-line');
      updateLineItem(line, 0);
    });
  });
});
